import PdfCoreMixins from './pdfCore'
import PdfPaginationMixins from './pdfPagination'

export default {
  mixins: [PdfCoreMixins, PdfPaginationMixins],
  data() {
    return {
      modalWidth: 480,
      visible: false,
    }
  },
  props: {
    modalTitle: {
      type: String,
      default: 'PDF 预览',
    },
    pdfScale: {
      type: [String, Number],
      default: 1.5,
    },
  },
  created() {
    this.loadFile(this.img.url)
  },
  methods: {},
}
